const {
  TYREHUB,
  PERFORMANCE,
  TRUCK,
  HOCKTYRE,
  HYPER,
  LUBRICANT,
  BRAKE,
  BATTERY,
  EKOTAYAR,
  ECOBATT,
} = require('../constants/companies')
const { MALAYSIA, SINGAPORE, INDONESIA } = require('../constants/countries-map')
const {
  CREDIT_LIMIT,
  BANKING_B2C,
  BANKING_B2B,
  CREDIT_CARD,
  EWALLET,
} = require('../constants/payment-methods')
const {
  PRODUCT_TYRE,
  PRODUCT_LUBRICANT,
  PRODUCT_BRAKE,
  PRODUCT_BATTERY,
} = require('../constants/product-types')
const regionalConfigs = {
  enablePaymentMethods: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  paymentMethods: {
    [MALAYSIA]: {
      [CREDIT_LIMIT]: {
        value: CREDIT_LIMIT,
        label: 'Available Credit',
        labelCheckout: 'Use Available Credit',
        enabled: true,
      },
      [BANKING_B2C]: {
        value: BANKING_B2C,
        label: 'Online Banking (FPX) Personal Account',
        enabled: true,
      },
      [BANKING_B2B]: {
        value: BANKING_B2B,
        label: 'Online Banking (FPX) Business Account',
        enabled: true,
      },
      [CREDIT_CARD]: {
        value: CREDIT_CARD,
        label: 'Credit/Debit Card',
        enabled: false,
      },
      [EWALLET]: {
        value: EWALLET,
        label: 'E-Wallet',
        enabled: false,
      },
    },
    [SINGAPORE]: {
      [CREDIT_LIMIT]: {
        value: CREDIT_LIMIT,
        label: 'Available Credit',
        labelCheckout: 'Use Available Credit',
        enabled: true,
      },
      [CREDIT_CARD]: {
        value: CREDIT_CARD,
        label: 'Credit/Debit Card',
        enabled: false,
      },
    },
    [INDONESIA]: {
      [CREDIT_LIMIT]: {
        value: CREDIT_LIMIT,
        label: 'Available Credit',
        labelCheckout: 'Use Available Credit',
        enabled: true,
      },
    },
  },
  currency: {
    [MALAYSIA]: 'MYR',
    [SINGAPORE]: 'SGD',
    [INDONESIA]: 'IDR',
  },
  currencyLabel: {
    [MALAYSIA]: 'RM',
    [SINGAPORE]: 'SGD',
    [INDONESIA]: 'RP',
  },
  maxPrice: {
    [MALAYSIA]: 3500,
    [SINGAPORE]: 700,
    [INDONESIA]: 10000000,
  },
  enableDeliveryDate: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  showDeliveryTimeForCS: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableSubSites: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableProcessedOrders: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableTaxColumn: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableEditableAddress: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableTyreBatch: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableHTSDealer: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableHTADealer: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableBillingSite: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  showStockOnlyForSales: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  requireItemRefForOrderItem: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  defaultHTGCompany: {
    [MALAYSIA]: TYREHUB,
    [SINGAPORE]: HOCKTYRE,
    [INDONESIA]: ECOBATT,
  },
  enableVisibleOrderSites: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableVisibleRoles: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  supportEmail: {
    [MALAYSIA]: 'support@htgroup.com.my',
    [SINGAPORE]: 'cs1@hocktyre.com',
    [INDONESIA]: 'PLEASE UPDATE THIS LATER', // TO DO
  },
  siteLabel: {
    [MALAYSIA]: 'Site',
    [SINGAPORE]: 'Warehouse',
    [INDONESIA]: 'Warehouse',
  },
  mergeBatch: {
    [MALAYSIA]: '0', //merge batch
    [SINGAPORE]: '1', //normal year only value
    [INDONESIA]: '0', //merge batch
  },
  fastDeliveryMode: {
    [MALAYSIA]: 'Fast Delivery by Taxi (Same Day)',
    [SINGAPORE]: 'Speedy Delivery (Payable)',
    [INDONESIA]: 'PLEASE UPDATE THIS LATER', // TO DO
  },
  cartTax: {
    [MALAYSIA]: [],
    [SINGAPORE]: [{ name: 'GST (7%)', tax: 0.07 }],
    [INDONESIA]: [],
  },
  enableRunflat: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  runflatTypes: {
    [MALAYSIA]: ['RFT'],
    [SINGAPORE]: [
      'RFT',
      'RF',
      'ZP RF',
      'R-F',
      'SSR RF',
      'RSC RF',
      'ACS ZP RF',
      'ZP',
      'EMT RF',
      'SSR',
    ],
    [INDONESIA]: [],
  },
  enableAccountDetails: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  showCopyOrderSlug: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableFastDeliveryExpress: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  fastDeliveryExpress: {
    [MALAYSIA]: {
      message: 'Purchase at least 2 pieces of tyres that are either run-flat or above 19 inch',
      check: (cart) => {
        const minimumPurchase = 2
        let expressDeliveryTotal = 0

        const orderItems = cart?.orderItems

        orderItems?.map((item) => {
          if (
            this.runflatTypes[MALAYSIA].includes(item?.product?.tyreType) ||
            item?.product?.rimSize >= 19
          ) {
            expressDeliveryTotal += item?.quantity
          }
        })
        return expressDeliveryTotal >= minimumPurchase
      },
    },
    [SINGAPORE]: {
      message: '',
      check: () => {},
    },
    [INDONESIA]: {
      message: '',
      check: () => {},
    },
  },
  enableVisibleOrderSites: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  showProductIDForSales: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  showReservedStock: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableFooter: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableManageTyreDatabase: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableClosingDate: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableCSAgent: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableInhouseDriver: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableEV: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableDeliverySchedule: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableDeliveryModeConfig: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  htgCompanies: {
    [MALAYSIA]: [TYREHUB, TRUCK, PERFORMANCE, LUBRICANT, BRAKE, BATTERY, EKOTAYAR],
    [SINGAPORE]: [HOCKTYRE, HYPER],
    [INDONESIA]: [ECOBATT],
  },
  htgCompanyOptions: {
    [MALAYSIA]: [
      {
        value: TYREHUB,
        label: 'HT Tyrehub',
        productTypes: [PRODUCT_TYRE],
      },
      {
        value: TRUCK,
        label: 'HT Truck Service',
        productTypes: [PRODUCT_TYRE],
      },
      {
        value: EKOTAYAR,
        label: 'HT EkoTayar',
        productTypes: [PRODUCT_TYRE],
      },
      {
        value: PERFORMANCE,
        label: 'HT Performance Tyre',
        productTypes: [PRODUCT_TYRE],
      },
      {
        value: LUBRICANT,
        label: 'HT Lubricant',
        productTypes: [PRODUCT_LUBRICANT],
      },
      {
        value: BRAKE,
        label: 'HT Brakes',
        productTypes: [PRODUCT_BRAKE],
      },
      {
        value: BATTERY,
        label: 'HT Battery',
        productTypes: [PRODUCT_BATTERY],
      },
    ],
    [SINGAPORE]: [
      {
        value: HOCKTYRE,
        label: 'Hock Tyre',
        // productTypes: [PRODUCT_TYRE, PRODUCT_BATTERY, PRODUCT_BRAKE], //add this back when brake is open for dealer
        productTypes: [PRODUCT_TYRE, PRODUCT_BATTERY],
      },
      {
        value: HYPER,
        label: 'Hyper Tyre & Battery',
        // productTypes: [PRODUCT_TYRE, PRODUCT_BATTERY, PRODUCT_BRAKE], //add this back when brake is open for dealer
        productTypes: [PRODUCT_TYRE, PRODUCT_BATTERY],
      },
    ],
    [INDONESIA]: [
      {
        value: ECOBATT,
        label: 'ECOBATT INDO LESTARI',
        productTypes: [PRODUCT_BATTERY],
      },
    ],
  },
  htgCompanyProductMapping: {
    [MALAYSIA]: {
      [PRODUCT_TYRE]: [TYREHUB, PERFORMANCE, TRUCK, EKOTAYAR],
      [PRODUCT_LUBRICANT]: [LUBRICANT],
      [PRODUCT_BATTERY]: [BATTERY],
      [PRODUCT_BRAKE]: [BRAKE],
    },
    [SINGAPORE]: {
      [PRODUCT_TYRE]: [HOCKTYRE, HYPER],
      [PRODUCT_BATTERY]: [HOCKTYRE, HYPER],
      // [PRODUCT_BRAKE]: [HOCKTYRE, HYPER], //add this back when brake is open for dealer
      [PRODUCT_BRAKE]: [],
    },
    [INDONESIA]: {
      [PRODUCT_BATTERY]: [ECOBATT],
    },
  },
  minimumPurchase: {
    [MALAYSIA]: 0,
    [SINGAPORE]: 0,
    [INDONESIA]: 0,
  },
  enableSalesCommission: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  salesCommissionEligiblePrice: {
    [MALAYSIA]: 500,
    [SINGAPORE]: undefined,
    [INDONESIA]: undefined,
  },
  salesCommissionEligibleDays: {
    [MALAYSIA]: 30,
    [SINGAPORE]: undefined,
    [INDONESIA]: undefined,
  },
  salesCommissionTiers: {
    [MALAYSIA]: {
      5: 20,
      10: 30,
      20: 50,
    },
    [SINGAPORE]: {},
    [INDONESIA]: {},
  },
  enableLandingPage: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableSalesDashboard: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableLalamove: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableSearchCard: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  // Promotion Config For SG
  enablePromoListFile: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enablePromotionMixBrand: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  keepStockProductTypes: {
    [MALAYSIA]: [PRODUCT_LUBRICANT],
    [SINGAPORE]: [PRODUCT_TYRE, PRODUCT_BATTERY],
    [INDONESIA]: [],
  },
  enableBatteryModelFilter: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableWarehouseFilter: {
    [MALAYSIA]: false,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enablePromoFilter: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableReferralCampaign: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableAnnouncement: {
    [MALAYSIA]: false,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableOrderStatusDisplay: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableInventoryLevel: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  showHiddenTyres: {
    [MALAYSIA]: '1',
    [SINGAPORE]: '0',
    [INDONESIA]: '0',
  },
  enableAutoSalesOrder: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  enableRewardPoints: {
    [MALAYSIA]: false,
    [SINGAPORE]: false,
    [INDONESIA]: true,
  },
  enableAdminCreateUser: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: true,
  },
  enableAdminUsers: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: true,
  },
  enableAdminTrialAccounts: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: true,
  },
  enableAdminPromotionBanners: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableAdminProductImages: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableAdminRetailPrice: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  enableAdminWebhook: {
    [MALAYSIA]: true,
    [SINGAPORE]: true,
    [INDONESIA]: false,
  },
  currencyFormats: {
    [MALAYSIA]: new Intl.NumberFormat('ms-MY', {
      style: 'currency',
      currency: 'MYR',
    }),
    [SINGAPORE]: new Intl.NumberFormat('en-SG', {
      style: 'currency',
      currencyDisplay: 'code',
      currency: 'SGD',
    }),
    [INDONESIA]: new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currencyDisplay: 'code',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }),
  },
  enableFeedback: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
  // Public (no-login) marketing promo campaigns
  enableCampaign: {
    [MALAYSIA]: true,
    [SINGAPORE]: false,
    [INDONESIA]: false,
  },
}

module.exports = regionalConfigs
